import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import WebsiteFeature from '../components/WebsiteFeature';
import FeaturesSection from '../components/FeaturesSection';
import NinetiesNailsCaseStudy from '../components/NinetiesNailsCaseStudy';
import MoreStoriesNotice from '../components/MoreStoriesNotice';
import CTASection from '../components/CTASection';

export default function HomePage() {
  return (
    <div>
      <HeroSection />
      <ServicesSection />
      <WebsiteFeature />
      <FeaturesSection />
      <NinetiesNailsCaseStudy />
      <MoreStoriesNotice />
      <CTASection />
    </div>
  );
}